 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		65: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"de626b8ee4d88d1be167f57cab2b12e79883089b","2":"c46d7bd4ef0bad2c8ae6694c0a7d5f3c35b9650a","3":"484bcb1e","4":"8673774c","5":"e3e86096e9e544b9c7e6fc37fc3a72808ad97f9f","6":"ff239f9d","7":"1f1b7ec6f60e730912385a8e27ac170fc7dd5933","8":"6986b5f4f0cc44f72ba9bb9f8ce891f253374fa5","9":"b48f68961065b8af3ecd461b12e1b1afd3be8be1","10":"bd8799aecb0e9c2f7f0289b7bb795f15366761a8","11":"0555c616fb1cb2822bc08cc3ab46ec4181616c22","12":"b4354bf585650b842bac327fd5def2f8ef3a8b99","14":"010d4efb886e51417a1370a65475f514f94e0f43","15":"31670b0552dfcc528a69b6af43c519250af9a791","16":"ac30fc0e3af3abe580c153b2e2cf4c51c4c1ef15","17":"c59d168741f0ce9c590acd3709d75fd86cc1617d","18":"c877b78a8f0f7c5270bfbaa1cedf2ad86f1e9724","20":"b637e9a5","21":"component---src-pages-404-js","22":"component---src-pages-about-js","23":"component---src-pages-aftonbladet-js","24":"component---src-pages-aktivering-congrats-js","25":"component---src-pages-aktivering-js","26":"component---src-pages-appguide-js","27":"component---src-pages-backtoschool-js","28":"component---src-pages-bundle-checkout-js","29":"component---src-pages-bundle-congrats-js","30":"component---src-pages-bundle-js","31":"component---src-pages-cancel-js","32":"component---src-pages-checkout-js","33":"component---src-pages-congrats-js","34":"component---src-pages-contacts-js","35":"component---src-pages-cookies-js","36":"component---src-pages-erbjudande-checkout-js","37":"component---src-pages-erbjudande-congrats-js","38":"component---src-pages-erbjudande-js","39":"component---src-pages-faq-js","40":"component---src-pages-forgot-password-js","41":"component---src-pages-hemundervisning-js","42":"component---src-pages-index-js","43":"component---src-pages-junibacken-checkout-js","44":"component---src-pages-junibacken-congrats-js","45":"component---src-pages-junibacken-js","46":"component---src-pages-junibacken-participate-js","47":"component---src-pages-junior-js","48":"component---src-pages-kampanj-checkout-js","49":"component---src-pages-kampanj-congrats-js","50":"component---src-pages-kampanj-js","51":"component---src-pages-login-js","52":"component---src-pages-mina-sidor-js","53":"component---src-pages-prenumeration-js","54":"component---src-pages-privacy-js","55":"component---src-pages-reactivate-congrats-js","56":"component---src-pages-reactivate-error-js","57":"component---src-pages-reactivate-js","58":"component---src-pages-register-js","59":"component---src-pages-senior-js","60":"component---src-pages-sponsring-js","61":"component---src-pages-startpage-js","62":"component---src-pages-terms-and-conditions-js","63":"component---src-pages-webinfo-js"}[chunkId]||chunkId) + "-" + {"0":"f40c1083566074ed3f20","1":"8cfd70ebc7650eacfdd3","2":"09999584e870817e42a5","3":"5e3810f88107498ada7f","4":"b66145f08163063d101d","5":"bd17d41e9aedc89aeb00","6":"76db68a3ff980cb5c0bf","7":"445edbd2e1d9e525c90e","8":"5c59d476d762e118a695","9":"5d911e5610e73b1d6aa9","10":"945294dcb8d9c6f2b044","11":"e934c991ea7bb2162a10","12":"fbc996f9b67fa51fac0f","14":"ef64aea47667f6f13784","15":"6889a34b1097ff55268e","16":"db8c563251917b80c407","17":"2a5ec5c8aea207f096e0","18":"cc200e88a46c93e786d2","20":"1763779b87ab33fa491d","21":"7e84d04fa8e720fcbc37","22":"076f782e79f89d33cc8e","23":"0d31a16602f33757bc53","24":"f7bf3c10fc0310117e3d","25":"c87a69e4120a6019a3eb","26":"9d10d4a3d00fa275ed97","27":"b99eaeadcab378685fc4","28":"fb00b5a08e1ea3da4562","29":"da71876bd9b1f06ff6dc","30":"3e46f2858b555b9e19e1","31":"b55e37468978d66dfa62","32":"2d526c454bd7c95dec07","33":"25fcac2764ef52dc2118","34":"3e5833cb5cdd713eedcb","35":"006ecc03107d6015c5fb","36":"484b4113e588ee1af930","37":"a1ca36063ed8cab2a98c","38":"57e36bd86136d38dda7a","39":"cb28fe5f9d10334a2ed2","40":"5296221f5680cbd0e9f2","41":"31842142905a45ac7745","42":"71e9b7f211da06ad4372","43":"d9e6919aeb2291d348bf","44":"05f8da66ac695ef8c5a5","45":"1a9eee9fe88a6b2db347","46":"e2a85a40c79e3d6ca14c","47":"338c7db67a2074634b7c","48":"481f8955b22b1cb73b25","49":"ee7dab4cc341d0a089ed","50":"38378df13d2794d107af","51":"6a4d6f5850157d4140a2","52":"d8df4abe9e4f0b7a3f8f","53":"2e1e3fc3a73140e8fbeb","54":"43636c2a57c20d56e23c","55":"452840cf58fd1b5d59cc","56":"1388916bcfd7bb2e905e","57":"991a863d1312f76fdbd5","58":"7e51ba93600f1e0813a5","59":"812db0a538d3d2627019","60":"cc5d51a3c28b6d1a3c98","61":"82fe12a4aa2a10d96161","62":"8fc9d5d20ab0493d984b","63":"a3bb8f7f8954da89568c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
